import React, {useState} from 'react';
import {Col, Form, Input, Row} from 'antd';
import Button from "../../common/Button/Button";

import './styles.scss';

import {ClientFormTypes} from "./ClientFormTypes";
import cx from "classnames";
import {ArrowRightOutlined, UserOutlined} from '@ant-design/icons';
import FormSectionHeader from "../../common/FormSectionHeader/FormSectionHeader";

interface Props {
    onSubmit: (values: any) => void
    applyDrawerStyles?: boolean,
}

function ClientForm(props: Props) {
    const {onSubmit, applyDrawerStyles} = props;
    const [form] = Form.useForm();
    // eslint-disable-next-line
    const [valuesForm, setValuesForm] = useState({});
    const [submittingForm, setSubmittingForm] = useState(false);

    async function onSubmitClick() {
        if (submittingForm) return false;
        setSubmittingForm(true);
        try {
            let valid = await form.validateFields();
            if (!valid.errorFields && onSubmit) {
                let values = form.getFieldsValue();
                await onSubmit(values);
            }
        } catch (e) {

        }
        setSubmittingForm(false);
    }

    function onValuesChange(v) {
        setValuesForm(v)
    }

    function renderButton() {
        if (applyDrawerStyles) {
            return (
                <div className='form-stickied-footer'>
                    <Button onClick={onSubmitClick} htmlType='submit' loading={submittingForm}
                            icon={<ArrowRightOutlined/>} iconPosition='right'>
                        Create Client
                    </Button>
                </div>
            )
        } else {
            return (
                <Button onClick={onSubmitClick} htmlType='submit' loading={submittingForm}>
                    Create Client
                </Button>
            )
        }
    }

    let initialValues = {}

    return (
        <Form className={cx('clients-form', {'as-drawer': applyDrawerStyles})} name="clients-form" layout='vertical'
              form={form} initialValues={initialValues}
              autoComplete="off" preserve={false} onValuesChange={onValuesChange} requiredMark='optional'>
            <div className='clients-form-content'>
                <Form.Item label='Client Name' name={ClientFormTypes.Name}
                           rules={[{required: true, message: 'This field is required.'}]}>
                    <Input size='large'/>
                </Form.Item>
                <FormSectionHeader text='Point of Contact' icon={<UserOutlined/>} help="A point of contact is required. Upon Client creation, an invitation will be sent to the point of contact's email."/>
                <Row gutter={16}>
                    <Col span={12}>
                        <Form.Item label='First Name' name={ClientFormTypes.PointOfContactFirstName}
                                   rules={[{required: true, message: 'This field is required.'}]}>
                            <Input size='large'/>
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item label='Last Name' name={ClientFormTypes.PointOfContactLastName}
                                   rules={[{required: true, message: 'This field is required.'}]}>
                            <Input size='large'/>
                        </Form.Item>
                    </Col>
                </Row>
                <Form.Item label='Email' name={ClientFormTypes.PointOfContactEmail}
                           rules={[{required: true, message: 'This field is required.'}]}>
                    <Input size='large'/>
                </Form.Item>
            </div>
            {renderButton()}
        </Form>
    );
}

export default ClientForm;